<template>
  <div>
    <!--    Desktop version-->
    <div
      v-if="!allowActionButtonsBreakpoint || ($vuetify.breakpoint.lgAndUp || isInDataTable)"
      class="action-buttons-list"
    >
      <v-btn
        v-for="button in actionButtons"
        :key="button.id"
        class="siteTree-btn"
        :class="`${button.isHidden ? 'd-none' : ''} ${button.desktopExtraClass}`"
        :color="button.iconColor || 'secondary'"
        :disabled="button.disabled || !valid"
        v-bind="{...button.desktopAttributes}"
        :icon="!!button.displayIcon && !button.label"
        :tile="!!button.displayIcon && !button.label"
        :data-cy="!customDataCy ? dataCy : `${customDataCy}-${button.id}`"
        @click="button.action"
      >
        <v-icon
          v-if="!!button.displayIcon || button.icon && !button.label"
          left
        >
          {{ button.icon }}
        </v-icon>
        {{ button.label }}
      </v-btn>
    </div>
    <!--    mobile version-->
    <div
      v-if="allowActionButtonsBreakpoint && actionButtons.length && $vuetify.breakpoint.mdAndDown && !isInDataTable"
      id="aquassist_fab"
      :class="fab ? 'fab-overlay' : ''"
      @click.self="closeFab"
    >
      <v-speed-dial
        v-model="fab"
        bottom
        right
        direction="top"
        transition="scale-transition"
      >
        <template #activator>
          <v-btn
            v-model="fab"
            color="secondary"
            dark
            fab
          >
            <v-icon
              :class="fab ? 'rotate-135' : null"
              large
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </template>

        <v-btn
          v-for="button in actionButtons"
          :key="button.id"
          fab
          small
          color="secondary"
          :class="button.isHidden ? 'd-none' : ''"
          :disabled="button.disabled || !valid"
          @click="button.action"
        >
          <label
            v-if="button.label"
            class="action-button-label"
          >
            {{ button.label }}
          </label>
          <v-icon>{{ button.icon }}</v-icon>
        </v-btn>
      </v-speed-dial>
    </div>
  </div>
</template>

<script>

export default {
    props: {
        actionButtons: {
            type: Array,
            default: () => [],
        },
        valid: {
            type: Boolean,
            default: true,
        },
        isInDataTable: {
            type: Boolean,
            default: false,
        },
        allowActionButtonsBreakpoint: {
            type: Boolean,
            default: true,
        },
        dataCy: {
            type: String,
            default: 'buttonStatusWO',
        },
        customDataCy: {
            type: String,
            default: '',
        },
    },
    data: () => ({
        fab: false,
    }),
    mounted() {
        const fabElem = document.getElementById('aquassist_fab');
        const vAppWrap = document.querySelector('.v-application--wrap');

        if (fabElem) {
            vAppWrap.classList.add('has-fab');
        }
    },
    destroyed() {
        const vAppWrap = document.querySelector('.v-application--wrap');
        vAppWrap.classList.remove('has-fab');
    },
    methods: {
        closeFab() {
            this.fab = false;
        },
    },

};
</script>

<style lang="scss" scoped>
  .fab-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(38, 56, 75, 0.74);
    z-index: 10;
  }

  .v-speed-dial {
    position: fixed;
    z-index: 101;
  }

  .action-button-label {
    position: absolute;
    right: calc(100% + 15px);
  }
  .btn-show-report {
    background: #ef4135;
  }
</style>
